<div class="zag-split-button">
  <button
    zagButton
    type="button"
    class="zag-split-button__primary"
    [zagButton]="zagButton()"
    [zagType]="zagType()"
    [zagSize]="zagSize()"
    [zagLoading]="zagLoading()"
    [disabled]="isDisabled()"
    [attr.aria-label]="primaryAriaLabel()"
    (click)="onPrimaryClick()"
  >
    @if (primaryIcon()) {
      <span [zagIcon]="primaryIcon()!"></span>
    }
    <span class="zag-button__text">{{ primaryLabel() }}</span>
  </button>

  <button
    zagButton
    type="button"
    class="zag-split-button__secondary"
    [zagButton]="zagButton()"
    [zagType]="zagType()"
    [zagSize]="zagSize()"
    [disabled]="isDisabled()"
    [attr.aria-label]="secondaryAriaLabel()"
    (click)="onSecondaryClick()"
  >
    <span [zagIcon]="secondaryIcon()"></span>
  </button>
</div>
